import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, A11y } from 'swiper/modules';
import './App.scss';
import 'swiper/css';
import 'swiper/css/pagination';

import logo from "./assets/imgs/logo.png";
import phone from "./assets/PHONE.png";
import banner_laptop from "./assets/laptop.png";
import banner_seven from "./assets/seven.png";
import banner_phone from "./assets/handphone.png";

import immersive from "./assets/immersive.png";
import engaging from "./assets/engaging.png";
import powered from "./assets/powered.png";
import arrow from "./assets/arrow.png";

import flag1 from "./assets/flag1.png";
import flag2 from "./assets/flag2.png";
import flag3 from "./assets/flag3.png";
import flag4 from "./assets/flag4.png";
import flag5 from "./assets/flag5.png";
import flag6 from "./assets/flag6.png";
import flag7 from "./assets/flag7.png";
import flag8 from "./assets/flag8.png";

import pp from "./assets/pp.png";
import cmd from "./assets/cmd.png";
import evo from "./assets/evo.png";
import sa from "./assets/sagaming.png";
import wm from "./assets/wmcasino.png";
import nextspin from "./assets/nextspin.png";
import sg from "./assets/sg.png";

import pagcor from "./assets/pagcor.png";
import bmm from "./assets/bmm.png";
import godaddy from "./assets/godaddy.png";
import itech from "./assets/itech.png";
import reco from "./assets/reco_cert.png";
import tt from "./assets/tt.png";

import usdt from "./assets/usdt.png";
import bitcoin from "./assets/bitcoin.png";
import eth from "./assets/ethereum.png";
import paynow from "./assets/paynow.png";

import facebook from "./assets/facebook.png";
import instagram from "./assets/instagram.png";
import youtube from "./assets/youtube.png";
import line from "./assets/line.png";

import lock from "./assets/lock.png";
import locker from "./assets/locker.png";
import puzzle from "./assets/puzzle.png";
import medal from "./assets/medal.png";

import myInfo from "./assets/imgs/Myinfo.webp";
import verify from "./assets/imgs/Verify.webp";

const scripts = [
];

function App() {

  const isLoaded = useScripts();
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [isShowMore, setIsShowMore] = useState(false);
  const [showMoreText, setShowMoreText] = useState("See more");

  useEffect(() => {
    document.getElementById("phoneImg").addEventListener("click", (e)=>{
      window.location.href = "http://www.n88sgd.com/home?affid=106";
    })

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };

  },[]);

  function calc(num){
    return Math.floor(num * 10000) / 10000;
  }

  function handleScroll(){
    const phoneContainer = document.getElementById("phoneContainer");
    const middleText = document.getElementById("middle-text");
    const phoneElem = document.getElementById("phone");
    const phoneImg = document.getElementById("phoneImg");
  
    const flag1 = document.getElementById("flag1");
    const flag2 = document.getElementById("flag2");
    const flag3 = document.getElementById("flag3");
    const flag4 = document.getElementById("flag4");
    const flag5 = document.getElementById("flag5");
    const flag6 = document.getElementById("flag6");
    const flag7 = document.getElementById("flag7");
    const flag8 = document.getElementById("flag8");
    
    const info1 = document.getElementById("info1");
    const info2 = document.getElementById("info2");
    const info3 = document.getElementById("info3");
    const info4 = document.getElementById("info4");
    
    const playsafe = document.getElementById("playsafe");
    const playnow = document.getElementById("playnow");

    const top = phoneContainer.getBoundingClientRect().top;

    if(top < 0){
      flag1.style.opacity = 0; 
      flag2.style.opacity = 0; 
      flag3.style.opacity = 0; 
      flag4.style.opacity = 0; 
      flag5.style.opacity = 0; 
      flag6.style.opacity = 0; 
      flag7.style.opacity = 0; 
      flag8.style.opacity = 0; 
    }else{
      flag1.style.opacity = 1; 
      flag2.style.opacity = 1; 
      flag3.style.opacity = 1; 
      flag4.style.opacity = 1; 
      flag5.style.opacity = 1; 
      flag6.style.opacity = 1; 
      flag7.style.opacity = 1; 
      flag8.style.opacity = 1; 
      flag1.style.transform = "translate(0,0)"; 
      flag2.style.transform = "translate(0,0)"; 
      flag3.style.transform = "translate(0,0)"; 
      flag4.style.transform = "translate(0,0)"; 
      flag5.style.transform = "translate(0,0)"; 
      flag6.style.transform = "translate(0,0)"; 
      flag7.style.transform = "translate(0,0)"; 
      flag8.style.transform = "translate(0,0)"; 
    }

    if(window.innerWidth > 1024){
      if(top <= -100){
        if(!phoneElem.classList.contains("fixed")){
          phoneElem.classList.add("fixed");
        }
      }else{
        if(phoneElem.classList.contains("fixed")){
          phoneElem.classList.remove("fixed");
        }
      }
      if(top <= 1000 && top > 0) {
        if(top > 700){
          flag1.style.transform = "translate(0, " + calc((1000 - top) * 1.2) + "px)"; 
        }else{
          flag1.style.transform = "translate(" + calc((700 - top) * 0.1) + "px, " + calc((1000 - top) * 1.2) + "px)"; 
        }
      }
      if(top <= 850 && top > 0) {
        if(top > 600){
          flag2.style.transform = "translate(0, " + calc((850 - top) * 1.05) + "px)"; 
        }else{
          flag2.style.transform = "translate(" + calc((600 - top) * 0.12) + "px," + calc((850 - top) * 1.05) + "px)"; 
        }
      }
      if(top <= 800 && top > 0) {
        if(top > 600){
          flag3.style.transform = "translate(0, " + calc((800 - top) * 1.02) + "px)"; 
        }else{
          flag3.style.transform = "translate(" + calc((600 - top) * 0.6) + "px," + calc((800 - top) * 1.02) + "px)"; 
        }
      }
      if(top <= 700 && top > 0) {
        if(top > 600){
          flag4.style.transform = "translate(0, " + calc((700 - top) * 1.01) + "px)"; 
        }else{
          flag4.style.transform = "translate(-" + calc((600 - top) * 0.1) + "px," + calc((700 - top) * 1.01) + "px)"; 
        }
      }
      if(top <= 950 && top > 0) {
        if(top > 700){
          flag5.style.transform = "translate(0, " + calc((950 - top) * 1.15) + "px)"; 
        }else{
          flag5.style.transform = "translate(-" + calc(700 - top) * 0.3 + "px," + calc((950 - top) * 1.15) + "px)"; 
        }
      }
      if(top <= 970 && top > 0) {
        if(top > 700){
          flag6.style.transform = "translate(0, " + calc((970 - top) * 1.25) + "px)"; 
        }else{
          flag6.style.transform = "translate(-" + calc(700 - top) * 0.9 + "px," + calc((970 - top) * 1.25) + "px)"; 
        }
      }
      if(top <= 950 && top > 0) {
        if(top > 700){
          flag7.style.transform = "translate(0, " + calc((950 - top) * 1.15) + "px)"; 
        }else{
          flag7.style.transform = "translate(" + calc(700 - top) * 0.85 + "px," + calc((950 - top) * 1.15) + "px)"; 
        }
      }
      if(top <= 850 && top > 0) {
        if(top > 700){
          flag8.style.transform = "translate(0, " + calc((850 - top) * 1.02) + "px)"; 
        }else{
          flag8.style.transform = "translate(-" + calc(700 - top) * 0.5 + "px," + calc((850 - top) * 1.02) + "px)"; 
        }
      }
      if(top <= -2500){
        if(phoneElem.classList.contains("fixed")){
          phoneElem.classList.remove("fixed");
        }
        if(!phoneElem.classList.contains("absolutePhone2")){
          phoneElem.classList.add("absolutePhone2");
        }
      }else{
        if(phoneElem.classList.contains("absolutePhone2")){
          phoneElem.classList.remove("absolutePhone2");
        }
      }
    }
    else if(window.innerWidth > 500){
      if(top <= -100){
        if(!phoneElem.classList.contains("fixed")){
          phoneElem.classList.add("fixed");
        }
      }else{
        if(phoneElem.classList.contains("fixed")){
          phoneElem.classList.remove("fixed");
        }
      }
      if(top <= 1000 && top > 0) {
        if(top > 700){
          flag1.style.transform = "translate(0, " + calc((1000 - top) * 1.2) + "px)"; 
        }else{
          flag1.style.transform = "translate(" + calc((700 - top) * 0.1) + "px, " + calc((1000 - top) * 1.2) + "px)"; 
        }
      }
      if(top <= 850 && top > 0) {
        if(top > 600){
          flag2.style.transform = "translate(0, " + calc((850 - top) * 1.05) + "px)"; 
        }else{
          flag2.style.transform = "translate(" + calc((600 - top) * 0.12) + "px," + calc((850 - top) * 1.05) + "px)"; 
        }
      }
      if(top <= 800 && top > 0) {
        if(top > 600){
          flag3.style.transform = "translate(0, " + calc((800 - top) * 1.02) + "px)"; 
        }else{
          flag3.style.transform = "translate(" + calc((600 - top) * 0.6) + "px," + calc((800 - top) * 1.02) + "px)"; 
        }
      }
      if(top <= 700 && top > 0) {
        if(top > 600){
          flag4.style.transform = "translate(0, " + calc((700 - top) * 1.01) + "px)"; 
        }else{
          flag4.style.transform = "translate(-" + calc((600 - top) * 0.1) + "px," + calc((700 - top) * 1.01) + "px)"; 
        }
      }
      if(top <= 950 && top > 0) {
        if(top > 700){
          flag5.style.transform = "translate(0, " + calc((950 - top) * 1.15) + "px)"; 
        }else{
          flag5.style.transform = "translate(-" + calc(700 - top) * 0.3 + "px," + calc((950 - top) * 1.15) + "px)"; 
        }
      }
      if(top <= 970 && top > 0) {
        if(top > 700){
          flag6.style.transform = "translate(0, " + calc((970 - top) * 1.25) + "px)"; 
        }else{
          flag6.style.transform = "translate(-" + calc(700 - top) * 0.6 + "px," + calc((970 - top) * 1.25) + "px)"; 
        }
      }
      if(top <= 950 && top > 0) {
        if(top > 700){
          flag7.style.transform = "translate(0, " + calc((950 - top) * 1.15) + "px)"; 
        }else{
          flag7.style.transform = "translate(" + calc(700 - top) * 0.55 + "px," + calc((950 - top) * 1.15) + "px)"; 
        }
      }
      if(top <= 850 && top > 0) {
        if(top > 700){
          flag8.style.transform = "translate(0, " + calc((850 - top) * 1.02) + "px)"; 
        }else{
          flag8.style.transform = "translate(-" + calc(700 - top) * 0.5 + "px," + calc((850 - top) * 1.02) + "px)"; 
        }
      }
      if(top <= -2500){
        if(phoneElem.classList.contains("fixed")){
          phoneElem.classList.remove("fixed");
        }
        if(!phoneElem.classList.contains("absolutePhone2")){
          phoneElem.classList.add("absolutePhone2");
        }
      }else{
        if(phoneElem.classList.contains("absolutePhone2")){
          phoneElem.classList.remove("absolutePhone2");
        }
      }
    }
    else {
      if(top <= 0){
        if(!phoneElem.classList.contains("fixed")){
          phoneElem.classList.add("fixed");
        }
      }else{
        if(phoneElem.classList.contains("fixed")){
          phoneElem.classList.remove("fixed");
        }
      }
      if(top <= 900 && top > 0) {
        if(top > 700){
          flag1.style.transform = "translate(0, " + calc((900 - top) * 1.25) + "px)"; 
        }else{
          flag1.style.transform = "translate(" + calc((700 - top) * 0.05) + "px, " + calc((900 - top) * 1.25) + "px)"; 
        }
      }
      if(top <= 750 && top > 0) {
        if(top > 600){
          flag2.style.transform = "translate(0, " + calc((750 - top) * 1.05) + "px)"; 
        }else{
          flag2.style.transform = "translate(" + calc((600 - top) * 0) + "px," + calc((750 - top) * 1.05) + "px)"; 
        }
      }
      if(top <= 720 && top > 0) {
        if(top > 600){
          flag3.style.transform = "translate(0, " + calc((720 - top) * 1.02) + "px)"; 
        }else{
          flag3.style.transform = "translate(" + calc((600 - top) * 0.2) + "px," + calc((720 - top) * 1.02) + "px)"; 
        }
      }
      if(top <= 650 && top > 0) {
        if(top > 600){
          flag4.style.transform = "translate(0, " + calc((650 - top) * 1.01) + "px)"; 
        }else{
          flag4.style.transform = "translate(-" + calc((600 - top) * 0.1) + "px," + calc((650 - top) * 1.01) + "px)"; 
        }
      }
      if(top <= 870 && top > 0) {
        if(top > 700){
          flag5.style.transform = "translate(0, " + calc((870 - top) * 1.2) + "px)"; 
        }else{
          flag5.style.transform = "translate(-" + calc(700 - top) * 0.05 + "px," + calc((870 - top) * 1.2) + "px)"; 
        }
      }
      if(top <= 890 && top > 0) {
        if(top > 700){
          flag6.style.transform = "translate(0, " + calc((890 - top) * 1.25) + "px)"; 
        }else{
          flag6.style.transform = "translate(-" + calc(700 - top) * 0.15 + "px," + calc((890 - top) * 1.25) + "px)"; 
        }
      }
      if(top <= 880 && top > 0) {
        if(top > 700){
          flag7.style.transform = "translate(0, " + calc((880 - top) * 1.2) + "px)"; 
        }else{
          flag7.style.transform = "translate(" + calc(700 - top) * 0.15 + "px," + calc((880 - top) * 1.2) + "px)"; 
        }
      }
      if(top <= 720 && top > 0) {
        if(top > 700){
          flag8.style.transform = "translate(0, " + calc((720 - top) * 1.02) + "px)"; 
        }else{
          flag8.style.transform = "translate(-" + calc(700 - top) * 0.12 + "px," + calc((720 - top) * 1.02) + "px)"; 
        }
      }
      if(top <= -2150){
        if(phoneElem.classList.contains("fixed")){
          phoneElem.classList.remove("fixed");
        }
        if(!phoneElem.classList.contains("absolutePhone")){
          phoneElem.classList.add("absolutePhone");
        }
      }else{
        if(phoneElem.classList.contains("absolutePhone")){
          phoneElem.classList.remove("absolutePhone");
        }
      }
    }

    if(top > 0){
      playnow.style.opacity = 0;
      playnow.style.transform = "translate(0, 0)"; 
    }else if(top <= 0 && top > -550){
      playnow.style.opacity = -top / 550; 
      playnow.style.transform = "translate(0, " + calc(top / 5.5) + "px)"; 
    }else if(top <= 550){
      playnow.style.opacity = 1; 
      playnow.style.transform = "translate(0, -100px)";
    }

    if(top < -550 && top > -700){
      playnow.style.opacity = 1; 
      playnow.style.transform = "translate(0, -100px)"; 
    }else if(top <= -700 && top > -1250){
      playnow.style.opacity = (top + 1250) / 550; 
      playnow.style.transform = "translate(0, " + (-100 + -calc((top + 700) / 5.5 * 2)) + "px)"; 
    }else if(top <= -1250){
      playnow.style.opacity = 0; 
      playnow.style.transform = "translate(0, 100px)"; 
    }

    if(window.innerWidth > 850){
      if(top > 0){
        middleText.style.opacity = 0; 
        middleText.style.transform = "translate(0, 0)"; 
      }else if(top <= 0 && top > -550){
        middleText.style.opacity = -top / 550; 
        middleText.style.transform = "translate(0, " + calc(top / 5.5) + "px)"; 
      }else if(top <= -550){
        middleText.style.opacity = 1; 
        middleText.style.transform = "translate(0, -100px)"; 
      }

      if(top < -550 && top > -700){
        middleText.style.opacity = 1; 
        middleText.style.transform = "translate(0, -100px)"; 
      }else if(top <= -700 && top > -1250){
        middleText.style.opacity = (top + 1250) / 550; 
        middleText.style.transform = "translate(0, " + (-100 + -calc((top + 700) / 5.5 * 2)) + "px)"; 
      }else if(top <= -1250){
        middleText.style.opacity = 0; 
        middleText.style.transform = "translate(0, 100px)"; 
      }
      if(top > -1250){
        phoneImg.style.transform = "scale(1)";
        info1.style.opacity = 0;
        info1.style.transform = "translate(450px, 0)";
        info2.style.opacity = 0;
        info2.style.transform = "translate(-450px, 0)";
      }else if(top <= -1250 && top > -2350){
        phoneImg.style.transform = "scale(" + (1 - (-top - 1250) / (1100 * 10) * 3) + ")";
        info1.style.opacity = (-top - 1250) / 1100;
        info1.style.transform = "translate(" + (550-(info1.style.opacity * 550)) + "px, 0)";
        info2.style.opacity = (-top - 1250) / 1100;
        info2.style.transform = "translate(-" + (550-(info2.style.opacity * 550)) + "px, 0)";
        info3.style.opacity = (-top - 1250) / 1100;
        info3.style.transform = "translate(" + (550-(info1.style.opacity * 550)) + "px, 0)";
        info4.style.opacity = (-top - 1250) / 1100;
        info4.style.transform = "translate(-" + (550-(info2.style.opacity * 550)) + "px, 0)";
      }else if(top <= -2350){
        phoneImg.style.transform = "scale(0.7)";
        info1.style.opacity = 1;
        info1.style.transform = "translate(0, 0)";
        info2.style.opacity = 1;
        info2.style.transform = "translate(0, 0)";
        info3.style.opacity = 1;
        info3.style.transform = "translate(0, 0)";
        info4.style.opacity = 1;
        info4.style.transform = "translate(0, 0)";
      }
      if(top > -2350){
        playsafe.style.opacity = 0;
      }else{
        playsafe.style.opacity = 1;
      }
    }
  }

  function toggerMenu(){
    if(!isShowMenu){
      document.body.style.overflow = "hidden";
    }else{
      document.body.style.overflow = "auto";
    }
    setIsShowMenu(!isShowMenu);
  }

  function toggleShowMore(){
    if(!isShowMore){
      setShowMoreText("See less");
    }else{
      setShowMoreText("See more");
    }
    setIsShowMore(!isShowMore);
  }
  
  return (
    <div className="App">
      <div className='w-100'>
        <div className='main-menu'>
          <img className='logo' src={logo} alt="" />
          {/* <ul className='menu'>
            <li>Home</li>
            <li>Games</li>
            <li>News</li>
            <li>Blog</li>
            <li>Video</li>
            <li>FAQ</li>
            <li>Contact</li>
          </ul>
          <div className='actions'>
            <button className='login'>Log In</button>
            <button className='register'>Register</button>
          </div>
          <div className='mobile-menu'>
            <div className={'menu-cover ' + (isShowMenu ? "" : "hide")} onClick={toggerMenu}></div>
            <sapn className="hamburger" onClick={toggerMenu}>
              <span className='hamburger-inner'></span>
            </sapn>
            <div className={'m-menu-container ' + (isShowMenu ? "" : "hide")}>
              <ul className='m-menu'>
                <li>Home</li>
                <li>Games</li>
                <li>News</li>
                <li>Blog</li>
                <li>Video</li>
                <li>FAQ</li>
                <li>Contact</li>
              </ul>
            </div>
          </div> */}
        </div>
        <div className='banner-section'>
          <div className='banners'>
            <img className='laptop' src={banner_laptop} alt="" />
            <img className='seven' src={banner_seven} alt="" />
            <img className='phone' src={banner_phone} alt="" />
            <div className='text'>
              <div className='title'>
                Sky is the limit, Payout in <span className='gradient'>Minutes</span>
              </div>
              <div className='description'>
                Singapore's Leading Online Casino Experience
              </div>
              <a href="http://www.n88sgd.com/home?affid=106" className='button'>
                Play Now
              </a>
            </div>
          </div>
        </div>
        <div className='whysp9-section'>
          <div className='sp9-logo'>
            <span>Why</span>
            <img className='logo' src={logo} alt="" />
          </div>
          <div className='sp9-desc'>
            N88 is the epitome of luxury gaming—where exclusivity, innovation, and prestige redefine the ultimate casino experience.
          </div>
          <div className='cards'>
            <div className='card'>
              <div>
                <img className='card-icon' src={immersive} alt="" />
              </div>
              <div className='title'>
                Immersive Worlds
              </div>
              <div className='description'>
                Enjoy the excitement of 1000+ Live Games from top providers, play anytime and anywhere.
              </div>
              <a className='plus' href="https://www.n88sgd.com/register?affid=106">
                <img src={arrow} alt="" />
              </a>
            </div>
            <div className='card'>
              <div>
                <img className='card-icon' src={engaging} alt="" />
              </div>
              <div className='title'>
                Engaging Gameplay
              </div>
              <div className='description'>
                Endless gameplay awaits, featuring exclusive Bonus Mini Games!
              </div>
              <a className='plus' href="https://www.n88sgd.com/register?affid=106">
                <img src={arrow} alt="" />
              </a>
            </div>
            <div className='card'>
              <div>
                <img className='card-icon' src={powered} alt="" />
              </div>
              <div className='title'>
                Powered by the Community
              </div>
              <div className='description'>
                Be part of a community of 75,000 + Players worldwide and established in global markets for over 10+ Years.
              </div>
              <a className='plus' href="https://www.n88sgd.com/register?affid=106">
                <img src={arrow} alt="" />
              </a>
            </div>
          </div>
        </div>
        <div className='country-section'>
          <div className='text'>
            Established since 2015 in China, Taiwan, Korea, Hong Kong, Thailand, Vietnam, Singapore and Malaysia.
          </div>
          <div className='flags'>
            <img className='flag1' id='flag1' src={flag1} alt="" />
            <img className='flag2' id='flag2' src={flag2} alt="" />
            <img className='flag3' id='flag3' src={flag3} alt="" />
            <img className='flag4' id='flag4' src={flag4} alt="" />
            <img className='flag5' id='flag5' src={flag5} alt="" />
            <img className='flag6' id='flag6' src={flag6} alt="" />
            <img className='flag7' id='flag7' src={flag7} alt="" />
            <img className='flag8' id='flag8' src={flag8} alt="" />
          </div>
          <div className='phone' id="phoneContainer">
            <div id='phone'>
              <div className='playsafe' id="playsafe">
                <span>Play Safe at</span>
                <img src={logo} alt="" />
              </div>
              <div className='middle-text' id='middle-text'>
                <div className='black'>Over 1000+ Games to Explore and Enjoy.</div>
                <a href="http://www.n88sgd.com/home?affid=106" className='red'>Play Now</a>
              </div>
              <img id='phoneImg' src={phone} alt="" />
              <div className='middle-text'>
              </div>
              <div className='split-info'>
                <div id="info1" className='info info1'>
                  <img src={locker} alt="" />
                  <div className='info-box'>
                    <div className='title'>Strict Data Privacy & Secure Withdrawals</div>
                    <div className='desc'>We follow GDPR & PAGCOR standards for <span className='red'>100% confidential transactions</span> and fast, secure cashouts.</div>
                  </div>
                </div>
                <div id="info2" className='info info2'>
                  <img src={lock} alt="" />
                  <div className='info-box'>
                    <div className='title'>Advanced Data Encryption</div>
                    <div className='desc'>We protect all transactions and data with SSL encryption and firewalls, <span className='red'>keeping your information 100% safe</span>.</div>
                  </div>
                </div>
                <div id="info3" className='info info3'>
                  <img src={puzzle} alt="" />
                  <div className='info-box'>
                    <div className='title'>Anti-Cheat & Fraud Prevention</div>
                    <div className='desc'>Our AI security blocks game manipulation, unfair play, and bots for a fair experience.</div>
                  </div>
                </div>
                <div id="info4" className='info info4'>
                  <img src={medal} alt="" />
                  <div className='info-box'>
                    <div className='title'>Certified Fair Play & Independent Audits</div>
                    <div className='desc'>All games are certified by iTech Labs & GLI for <span className='red'>true</span> random results. Our licensed RNG system ensures <span className='red'>fair</span> games.</div>
                  </div>
                </div>
              </div>
              <div className='playnow' id='playnow'>
                <div className='black'>Over 1000+ Games to Explore and Enjoy.</div>
                <a href="http://www.n88sgd.com/home?affid=106" className='red'>Play Now</a>
              </div>
            </div>
          </div>
        </div>
        <div className='bottom-section'>
        <Swiper 
          style={{
            "--swiper-pagination-color": "#2C1212",
            "--swiper-pagination-bullet-size": "12px",
          }}
          modules={[Pagination, A11y]}
          pagination={{ clickable: true }}
          spaceBetween={50}
          slidesPerView={1}
          onSlideChange={() => console.log('slide change')}
          onSwiper={(swiper) => console.log(swiper)}
        >
          <SwiperSlide>
            <div className='info info1'>
              <img src={locker} alt="" />
              <div className='info-box'>
                <div className='title'>Strict Data Privacy & Secure Withdrawals</div>
                <div className='desc'>We follow GDPR & PAGCOR standards for <span className='red'>100% confidential transactions</span> and fast, secure cashouts.</div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className='info info2'>
              <img src={lock} alt="" />
              <div className='info-box'>
                <div className='title'>Advanced Data Encryption</div>
                <div className='desc'>We protect all transactions and data with SSL encryption and firewalls, <span className='red'>keeping your information 100% safe</span>.</div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className='info info3'>
              <img src={puzzle} alt="" />
              <div className='info-box'>
                <div className='title'>Anti-Cheat & Fraud Prevention</div>
                <div className='desc'>Our AI security blocks game manipulation, unfair play, and bots for a fair experience.</div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className='info info4'>
              <img src={medal} alt="" />
              <div className='info-box'>
                <div className='title'>Certified Fair Play & Independent Audits</div>
                <div className='desc'>All games are certified by iTech Labs & GLI for <span className='red'>true</span> random results. Our licensed RNG system ensures <span className='red'>fair</span> games.</div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        </div>
        <div className='provider-section'>
          <div className='text'>Our Player's Favorites</div>
          <div className='providers'>
            <img src={pp} alt="" />
            <img src={cmd} alt="" />
            <img src={evo} alt="" />
            <img src={sa} alt="" />
            <img src={wm} alt="" />
            <img src={nextspin} alt="" />
            <img src={sg} alt="" />
          </div>
        </div>
        <div className='footer'>
          <div className='footer-top'>
            <div className='gaming-license'>
              <div className='title'>Gaming License</div>
              <img className='pagcor' src={pagcor} alt="" />
              <div className='desc'>N88 offer wide range of highest quality gaming products to our players. Our Customer Support Team is available to assist you 24 hours a day. All personal information will be treated and stored at the strictest and most confidential way.</div>
            </div>
            <div className='certificated'>
              <div className='title'>Certificated By</div>
              <div className='cert'>
                <img src={bmm} alt="" />
                <img src={godaddy} alt="" />
                <img src={itech} alt="" />
                <img src={reco} alt="" />
                <img src={tt} alt="" />
              </div>
            </div>
            <div className='payment'>
              <div className='title'>Payment Method</div>
              <div className='methods'>
                <img src={usdt} alt="" />
                <img src={bitcoin} alt="" />
                <img src={eth} alt="" />
                <img src={paynow} alt="" />
              </div>
            </div>
            <div className='follow'>
              <div className='title'>Follow Us</div>
              <div className='social'>
                <img src={facebook} alt="" />
                <img src={instagram} alt="" />
                <img src={youtube} alt="" />
                <img src={line} alt="" />
              </div>
            </div>
          </div>
          <div className='footer-bottom'>
            <div className='title'>N88 Trusted Online Casino Singapore</div>
            <div className='desc'>
              Singapore's #1 Trusted Online Casino & Gaming Platform - Play Anytime, Win Big!
              <br/><br/>
              Welcome to N88, Singapore's premier online gaming and casino platform, offering an unrivaled selection of live casino games, slots, poker, sports betting, and VIP experiences. Whether you're a casual player or a high-roller, we provide a seamless, secure, and thrilling gaming experience with fast payouts, exclusive bonuses, and 24/7 customer support.
              <br/><br/>
              <div className={isShowMore ? "" : "hide"}>
                Why Choose N88 Online Casino?
                Largest Game Selection - Live Dealer Casino, Slots, Sports Betting, Poker, Fishing Games, and More
                Secure & Instant Transactions - Supports PayNow, Bank Transfers, Crypto, E-wallets
                Exclusive VIP Club - Get access to a 24/7 Concierge & Dedicated Account Manager
                Fastest Payouts - Enjoy same-day withdrawals with no hidden fees
                Generous Welcome Bonuses & Daily Promotions - Claim free spins, cashback, and deposit rewards
                Mobile-Friendly Gaming - Play on any device with our fully optimized mobile casino
                100% Safe & Licensed Platform - Advanced security and fair gaming policies
                <br/><br/>
                Live Casino & Online Slots - Real Thrills, Real Wins
                Experience the excitement of live casino action with professional dealers in HD streaming. Play Baccarat, Blackjack, Roulette, and Dragon Tiger with real-time interaction. Love online slots? Choose from thousands of slot machines with progressive jackpots, high RTP, and mega winnings.
                <br/><br/>
                Exclusive VIP Club - Luxury Gaming at Its Best
                Our VIP members receive personalized rewards, high-limit tables, exclusive bonuses, priority withdrawals, and a 24/7 dedicated concierge service. Elevate your gaming experience with the finest online casino in Singapore.
                <br/><br/>
                Fast & Secure Payments - Play with Confidence
                We offer instant deposits and lightning-fast withdrawals through PayNow, bank transfers, e-wallets, and cryptocurrency. Enjoy a hassle-free experience with zero hidden fees and top-tier security encryption.
                <br/><br/>
                Join Singapore's Leading Online Casino Today!
                Register now at N88 and claim your welcome bonus. Play your favorite casino games, win big, and cash out instantly. Whether you're into slots, live dealers, or high-stakes betting, we bring Las Vegas-style gaming to your screen.
              </div>
            </div>
          </div>
          <div className='copyright'>
            <a className='seemore' onClick={toggleShowMore}>{showMoreText}</a>
            <span>Copyright N88 | Noble © 2025. All rights reserved.</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function loadScript( url ) {
  return new Promise((resolve, reject) => {
    var script = document.createElement( "script" )
    script.type = "text/javascript";
    if(script.readyState) {  // only required for IE <9
      script.onreadystatechange = function() {
        if ( script.readyState === "loaded" || script.readyState === "complete" ) {
          script.onreadystatechange = null;
          resolve();
        }
      };
    } else {  //Others
      script.onload = function() {
        resolve();
      };
    }
    script.src = url;
    document.getElementsByTagName( "head" )[0].appendChild( script );
  })
}

const useScripts = () => {  
  const [isLoaded, setLoaded] = useState(false);
  useEffect(() => {    
    Promise
    .all(scripts.map(script => loadScript(script)))
    .then(() => setLoaded(true));
  }, []);
  return isLoaded;
}

export default App;
